import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";

import useRouteOfAdministrationList from "./hooks/useRouteOfAdministrationList";

const RouteOfAdministrationList = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData = null,
}) => {
  const routeOfAdministrationListData = useRouteOfAdministrationList(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={routeOfAdministrationListData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {routeOfAdministrationListData.screen_title} -{" "}
          <span className="heading-cod">
            {routeOfAdministrationListData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={routeOfAdministrationListData.formFields}
        dropdownValues={routeOfAdministrationListData.dropdownValues}
        paramsData={routeOfAdministrationListData.paramsData}
        updataParamData={routeOfAdministrationListData.updateParamData}
      />
      <ButtonsSection ctaButtons={routeOfAdministrationListData.ctaButtons} />
      <DisplayTable
        data={routeOfAdministrationListData.data}
        parmKey={routeOfAdministrationListData.parmKey}
        menuOptions={routeOfAdministrationListData.menuOptions}
        tableHeaders={routeOfAdministrationListData.columnDef}
        setRowData={routeOfAdministrationListData.setRowData}
        selectedPriceSchedules={routeOfAdministrationListData.selectedRows}
        setSelectedPriceSchedules={
          routeOfAdministrationListData.setSelectedRows
        }
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={routeOfAdministrationListData.first}
          rows={routeOfAdministrationListData.rows}
          totalRecords={routeOfAdministrationListData.totalRecords}
          currentPage={routeOfAdministrationListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={routeOfAdministrationListData.onPageChange}
        />
      </div>
      {routeOfAdministrationListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={routeOfAdministrationListData.isConfirmationModalOpen}
          onRequestClose={routeOfAdministrationListData.closeConfirmationModal}
          onBack={routeOfAdministrationListData.closeConfirmationModal}
          onSave={routeOfAdministrationListData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={routeOfAdministrationListData.setSelectedOption}
        />
      )}
      {routeOfAdministrationListData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={routeOfAdministrationListData.isHideConfirmationModalOpen}
          onRequestClose={
            routeOfAdministrationListData.closeHideConfirmationModal
          }
          onBack={routeOfAdministrationListData.closeHideConfirmationModal}
          onSave={routeOfAdministrationListData.hidePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={
            routeOfAdministrationListData.setHideSelectedOption
          }
        />
      )}
    </div>
  );
};

export default RouteOfAdministrationList;
